/* eslint-disable */
// NOTE :: DO NOT EDIT :: this file is automatically generated by generate-environment-variables.js node script

export const envVariables: { [key: string]: string } = {
  CIRCLE_TAG: 'prod-insightful-v49',
  PROJECT: 'insightful',
  PRODUCT: 'insightful',
};
export const latestTag: string = 'prod-insightful-v49';
export const latestVersion: string = 'v49';
export const versions: { app: { [key: string]: string }, branch: string, npm_version: string, revision: string } = {
  app: {
    purposeful: '9.1.0',
    insightful: '3.2.0',
  },
  branch: 'HEAD',
  npm_version: '167.0.0',
  revision: '41103abc9',
};
/* eslint-enable */
